export default __webpack_public_path__ + "static/media/stripe.f09e2cdf.svg";